export default {
	directivePrefix: ''
}



// WEBPACK FOOTER //
// ./~/luminate/src/config.js